import { render, staticRenderFns } from "./TradeConfirmAddressList.vue?vue&type=template&id=5836fb0c"
import script from "./TradeConfirmAddressList.vue?vue&type=script&lang=js"
export * from "./TradeConfirmAddressList.vue?vue&type=script&lang=js"
import style0 from "./TradeConfirmAddressList.vue?vue&type=style&index=0&id=5836fb0c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports